import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import trophyIcon from '@/assets/app/images/icon/icon-trophy.png';
import useAppStore from '@/shared/store/UseAppStore';
import { getUploadsUrl, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';
import BookPerson from './BookPerson';
import StripedBgImage from '@/assets/app/images/common/book-icon-bg.png';

import '@/assets/app/css/book.css';

const Book: React.FC = () => {
  const navigate = useNavigate();
  const { setIsShowBottomNavigation, setIsShowProfileHeader } = useAppStore();
  const [list, setList] = useState<BookEraCategory[]>([]);
  const [eraCategory, setEraCategory] = useState<BookEraCategory>();
  const [showPerson, setShowPerson] = useState(false);

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/book`,
      {},
      (response: AxiosResponse<CommonResult>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setList(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    setIsShowBottomNavigation(true);
    setIsShowProfileHeader(true);
    loadData();
  }, []);

  const handleShowPerson = (category: BookEraCategory) => {
    setEraCategory(category);
    setShowPerson(true);
    // if (character.unlocked) {
    //   // 캐릭터 상세 정보 표시
    //   console.log('Character clicked:', character.name);
    // }
  };

  if (list.length === 0) {
    return <></>;
  }

  return (
    <Fragment>
      <div className="page-container page-container--white" style={{ padding: 20 }}>
        <div
          className="flex"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            columnGap: 4,
            justifyItems: 'center',
            rowGap: 25,
          }}
        >
          {list.map((item, idx) => {
            const percentage = Math.min(
              Math.max((item.completedPerson / item.totalPerson) * 100, 0),
              100,
            );
            return (
              <div className="flex flex-col gap-5">
                <div
                  style={{
                    position: 'relative',
                  }}
                  className={`theme-${item.themeColor}`}
                  onClick={() => handleShowPerson(item)}
                >
                  <h2 className="absolute left-1/2 -translate-x-1/2 w-full text-center book-profile-title">
                    {item.categoryName}
                  </h2>
                  <div className="book-profile-bg">
                    <img
                      src={StripedBgImage}
                      alt="Striped Background"
                      className="striped-bg-layer"
                    />
                    <div className="book-profile">
                      <img src={`${getUploadsUrl()}/person/${item.imageFilename}`} />{' '}
                    </div>
                  </div>
                </div>

                <div className="relative flex justify-center">
                  <div
                    className="book-progress-total"
                    style={{
                      position: 'absolute',
                      width: '80%',
                      bottom: 0,
                    }}
                  >
                    <div className="book-progress" style={{ width: `${percentage}%` }}></div>
                    <div className="book-progress-text-area">
                      <span className="book-progress-text">
                        {item.completedPerson}/{item.totalPerson}
                      </span>
                    </div>
                  </div>

                  {item.totalPerson === item.completedPerson && (
                    <img className="book-trophy-icon" src={trophyIcon} />
                  )}
                </div>
              </div>
              // <CategoryCard key={idx} category={item} />
            );
          })}
        </div>
      </div>
      {showPerson && <BookPerson closeFunc={() => setShowPerson(false)} category={eraCategory} />}
    </Fragment>
  );
};

export default Book;
